
import { browserHistory } from 'react-router';
import { addNewPath } from '../routes';
import { MainMenu, saveLastVisitRoute } from '../routes';
import {
    PreviewFileAysnc,
    dynamicPreview,
    PreviewFile
} from '../pages/component/FilePreview.js';
import Big from 'big.js';
import {
    cnyFormat,
    intToZH,
    getDays
} from './utils';
import * as CrpytoKit from '../cfcaclass/CrpytoKit';
import { loading } from '../pages/component/Loading/index';
window.CrpytoKit = CrpytoKit;
tool.UpdateCertificate = function (cb) {
  let data = { p10: '', userId: '', clientId: '' };
  CrpytoKit.PKCS10Requisition_SingleCert().then((p10) => {
    data.p10 = p10;
    return CrpytoKit.GetContainer();
  }).then((d) => {
    data.clientId = d.result;
    console.log(data);
    let res = {
      errorcode: '0000',
      data
    };
    cb(res);
  }).catch((err) => {
    let resObj = {
      errorcode: '1111',
      result: err.result
    };
    cb(resObj);
  });
};
tool.DownloadCert = function (params, cb) {
  CrpytoKit.InstallCert(1, params).then((res) => {
    let resObj = {
      errorcode: '0000',
      result: res.toString()
    };
    console.log(res);
    cb(resObj);
  }).catch((err) => {
    console.log(err);
    let resObj = {
      errorcode: '1111',
      result: err.result
    };
    cb(resObj);
  });
};
tool.getCfcaParmas = function (cb) {
  function success(res) {
    console.log(res);
  }
  let data = { p10: '', userId: '', clientId: '' };
    // 获取p10
  CrpytoKit.PKCS10Requisition_SingleCert().then((d) => {
    data.p10 = d;
    return CrpytoKit.GetContainer(); // 获取keyname
  }).then((d) => {
    data.clientId = d.result;
    let res = {
      code: '0000',
      data
    };
    cb(res);
  })
    .catch((err) => {
      console.log(err);
      let res = {
        errorcode: '1111',
        result: err.result
      };
      cb(res);
    });
};
// 格式化方法
tool.cnyFormat = cnyFormat;
tool.intToZH = intToZH;
tool.getDays = getDays;
tool.Big = Big;
// 自定请求临时预览
tool.dynamicPreview = dynamicPreview;
tool.loading = loading;
// id预览
tool.PreviewFileAysnc = PreviewFileAysnc;
// 直接地址预览
tool.PreviewFile = PreviewFile;
// 跨域下载图片
function downloadIamge(imgsrc, name) { // 下载图片地址和图片名
  let image = new Image();
    // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous');
  image.onload = function () {
    let canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    let context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, image.width, image.height);
    let url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据

    let a = document.createElement('a'); // 生成一个a元素
    let event = new MouseEvent('click'); // 创建一个单击事件
    a.download = name || 'photo'; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgsrc;
}
tool.downloadIamgeByUrl = downloadIamge;
// 预览cfca协议
tool.PreviewCfca = function () {
  PreviewFileAysnc('1498906563264122880', 'application/pdf');
};
// 密码加密
tool.encrypt = (val) => {
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrqKuQ6jaDcJbOnLGBP6RG7rcR6FcS67HR88h+
    OURF9KpQ5CEaapxgMkFP/z1hrQ2bMGC3x5jEAdX/YruPjsw+2PiXaoisRUGbGAFf4fnD+aoccY22
    wHBXxCqk/+4faxOF3lT2Xa7HDoE4wPTjL7eV00VfmRKQBpl3JEpwDYGx3wIDAQAB
    -----END PUBLIC KEY-----`);
  return encrypt.encrypt(val);
};

// 密码加密
tool.getUTF8Bytes = (str, radix, offset) => {
  let bytes = [];
  let len = str.length;
  for (let i = 0; i < len; ++i) {
    let code = str.charCodeAt(i);
    if (code >= 0x10000 && code <= 0x10ffff) {
      bytes.push((code >> 18) | 0xf0);                // 第一个字节
      bytes.push(((code >> 12) & 0x3f) | 0x80);
      bytes.push(((code >> 6) & 0x3f) | 0x80);
      bytes.push((code & 0x3f) | 0x80);
    } else if (code >= 0x800 && code <= 0xffff) {
      bytes.push((code >> 12) | 0xe0);
      bytes.push(((code >> 6) & 0x3f) | 0x80);
      bytes.push((code & 0x3f) | 0x80);
    } else if (code >= 0x80 && code <= 0x7ff) {
      bytes.push((code >> 6) | 0xc0);
      bytes.push((code & 0x3f) | 0x80);
    } else {
      bytes.push(code);
    }
  }

  return bytes.map(item => {
    let displacement = item ^ 5;
    return (displacement.toString(radix || 2));
  }).join(',');
};


tool.jumpNewView = (path, prams) => {
  let pramsStr = '';
  for (let key in prams) {
    pramsStr += `${key}=${prams[key]}&`;
  }
  let win = window.open(`${path}?${pramsStr}`, '_blank');
  win.focus();
};

/**
 * 平台commonClient.simplecall方法
 * @param req 服务输入
 * @param url 调用地址
 * @param logMsg 控制台日志
 */
tool.simpleCall = function (req, url, logMsg) {
  let datas;
  if (!url) { tool.sgiLogger.error('服务调用地址为空！'); return; }
  let success = function (res) {
    if (res && res.head && res.head.code == '0000') {
      tool.sgiLogger.info(logMsg || '服务调用成功 res :', res);
      datas = res.body || true;
    } else {
      tool.sgiLogger.error(logMsg || '服务调用失败！', res.head ? res.head.msg : null);
      tool.popMessage((res && res.head && res.head.msg) ? res.head.msg : '服务器繁忙，请稍后！', 'warn');
      datas = false;
    }
  };
  commonClient.simplecall(url, req, success);
  return datas;
};

/** *
*  简版的分批查询
* @param req 服务请求对象
* @param url 服务调用地址
* @param tb_id 列表绑定的控件id
* @param tb_db 列表绑定的实例名
* @param objFct 当前对象工厂
*
***/
tool.simpBatchCall = function (req, url, tb_id, tb_db, objFct) {
  let respFunc = function (res) {
    if (res && res.head && res.head.code === '0000') {
      tool.sgiLogger.info('数据查询成功 res :', res);
      objFct.set(tb_db, res.body || []);
      tool.refreshTable(tb_id, objFct, true);
    } else {
      tool.sgiLogger.error('数据查询失败 res :', res);
      tool.popMessage('数据查询失败，请稍后重试！', 'warning');
    }
  };
  tool.tableBatchSelect(tb_id, objFct, url, req, respFunc, true);
};

let extra = {};

tool.setLoginInfoExtra = function (info) {
  Object.assign(extra, info);
};

tool.getLoginInfo = function () {
  return {
    appId: 'miap',
    token: tool.getCookie('token'),
    chnlId: '01',
    ...extra
  };
};

tool.getHeaderInfo = function () {
  return {
    appId: 'miap',
    token: tool.getCookie('token'),
    chnlId: '01'
  };
};

tool.popUIByUcv = function (uid, transferData, curtitle) {
    // uid配置到你的那个路由方法

    // uid
  if (!uid) {
    return;
  }

    // json判断，如果不是json，回去
  if (!transferData) {
    transferData = {};
  }
    // if (!transferData.isJSON()) {
    //     transferData = {};
    // }
  transferData.uid = uid;
  transferData.name = curtitle;
  let path = '/main/' + uid;
    // path,UIPreview
  addNewPath(path);

  tool.jumpByBrowserHistory(path, transferData);
    // window.MainBreadcrumb.pushItem({ path: path, uid: uid, name: curtitle });
};
// 修改 不启用了
// tool.popUIByUcv = function (uid, objFct, curtitle) {
//     //uid配置到你的那个路由方法

//     let path = "/main/" + uid;
//     //path,UIPreview
//     addNewPath(path);

//     //由相应的平台自主实现,无法做公共的
//     browserHistory.push({
//         pathname: path,
//         state: {
//             uid: uid, objFct: objFct,
//             title: curtitle,
//             popUIByUcv: true
//         }
//     });

//     window.MainBreadcrumb.pushItem({ path: path, uid: uid, title: curtitle });

// };

tool.goBack = function (n) {
  if (n) {
    browserHistory.go(n);
    MainBreadcrumb.goBack(n);
  } else {
    browserHistory.goBack();
    MainBreadcrumb.goBack();
  }
};

tool.go = function (n) {
  browserHistory.go(n);
  MainBreadcrumb.goBack(n);
};

tool.logout = function () {
  tool.deleteCookie('id');
  tool.deleteCookie('name');
  tool.deleteCookie('mbl');
  tool.deleteCookie('userType');
  tool.deleteCookie('nickname');
  tool.deleteCookie('token');
  tool.deleteCookie('enterpriseId');
  tool.deleteCookie('enterpriseName');
  tool.deleteCookie('loginInfo');
  tool.deleteCookie('workbenchId');
  console.log('tool.logout============');

  const openSso = tool.getCookie('openSso');
  const service = window.location.protocol + '//' + window.location.host + '/';
  if (openSso) {
    let url = sgiConfig.casBaseUrl + '/logout?service=' + encodeURIComponent(service);
    console.log('useSso.ts  ssoLoginOut  url: ', url);
    window.location.href = url;
    return;
  }
    // tool.popSingleUI('/');
    // tool.popSingleUI('/?openSso=false');
  let path = openSso ? '/' : '/?openSso=false';
  console.log('path', path);
  tool.popSingleUI(path);
    // tool.popSingleUI('/');
};

tool.goError = function (ErrContent) {
  ErrContent.name = '错误信息';
  tool.jumpByBrowserHistory('/main/cmmnError', { ErrContent });
};

tool.popSingleUI = function (path, values, curtitle) {
    // browserHistory.push({
    //     pathname: path,
    //     state: values
    // });
    // window.MainBreadcrumb.pushItem({ path: path, uid: '', title: curtitle });
  if (!values) {
    values = {};
  }
  values.uid = null;
  values.name = curtitle;
  tool.jumpByBrowserHistory(path, values);
    // if (window.MainBreadcrumb) {
    //     window.MainBreadcrumb.pushItem({ path: path, uid: undefined, name: curtitle });
    // }
};

// tool.setCookie = function (key, val, time) {//设置cookie方法
//     if (!val) {
//         val = "";
//     }
//     var time = arguments[2] ? arguments[2] : 30;
//     var date = new Date(); //获取当前时间
//     var expiresDays = time;  //将date设置为n天以后的时间
//     date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
//     document.cookie = sgiConfig.abb_project + "-" + key + "=" + val + ";expires=" + date.toGMTString() + ";path=/";  //设置cookie
// }

// tool.getCookie = function (key) {//获取cookie方法
//     /*获取cookie参数*/
//     var getCookie = document.cookie.replace(/[ ]/g, "");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
//     var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
//     var tips;  //声明变量tips
//     for (var i = 0; i < arrCookie.length; i++) {   //使用for循环查找cookie中的tips变量
//         var arr = arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
//         if (sgiConfig.abb_project + "-" + key == arr[0]) {  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
//             tips = arr[1];   //将cookie的值赋给变量tips
//             break;   //终止for循环遍历
//         }
//     }
//     return tips;
// }

tool.deleteAllCookie = function () {
  let getCookie = document.cookie.replace(/[ ]/g, '');
  let arrCookie = getCookie.split(';');  // 将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
  for (let i = 0; i < arrCookie.length; i++) {   // 使用for循环查找cookie中的tips变量
    let arr = arrCookie[i].split('=');   // 将单条cookie用"等号"为标识，将单条cookie保存为arr数组
    tool.deleteCookie(arr[0]);
  }
};

// tool.deleteCookie = function (key) { //删除cookie方法
//     var date = new Date(); //获取当前时间
//     date.setTime(date.getTime() - 10000); //将date设置为过去的时间
//     tool.sgiLogger.info(date.toGMTString())
//     let path = ";path=/";
//     document.cookie = sgiConfig.abb_project + "-" + key + "=v; expires =" + date.toGMTString() + path;//设置cookie

// }
// // 批量删除cookie-根据前缀
// tool.removeCookieByPrefix = function (prefix) {
//     if (!prefix) return;
//     let preLength = prefix.length;
//     var getCookie = document.cookie.replace(/[ ]/g, "");
//     var arrCookie = getCookie.split(";");
//     for (var i = 0; i < arrCookie.length; i++) {
//         var arr = arrCookie[i].split("=");
//         let key = arr[0];
//         let pre = key.substr(0, preLength);
//         if (prefix === pre) {
//             document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
//             break;
//         }
//     }
// }


tool.getCurrentDate = () => {
  let date = new Date();
  let seperator1 = '-';
  let seperator2 = ':';
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
  }
  let currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
        + ' ' + date.getHours() + seperator2 + date.getMinutes()
        + seperator2 + date.getSeconds();
  return currentdate;
};

let getLastRoute = function (data, path) {
  let lastRoute = {};
  for (let i = 0; i < data.length; i++) {
    if (data[i].children) {
      lastRoute = { ...lastRoute, ...getLastRoute(data[i].children, path) };
    } else if (data[i].describe == path) {
      lastRoute = { ...lastRoute, ...data[i] };
    }
  }
  return lastRoute;
};

// tool.BreadcrumbArr = [
//     {
//         path: "/main",
//         name: "首页",
//         uid: null
//     }
// ];
tool.initBreadcrumbArr = () => {
  window.MainBreadcrumb.refresh([]);
};
tool.addBreadcrumbArr = (path, data) => {
  if (window.MainBreadcrumb) {
    window.MainBreadcrumb.pushItem({ path: path, uid: data.uid, name: data.name });
  }
};
tool.getRouterQuery = (uuid) => {
  let data = JSON.parse(unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + uuid)));
  return data;
};
tool.jumpByBrowserHistory = (path, data) => {
  if (!path) {
    return;
  }

  tool.sgiLogger.info(path, data);
  tool.addBreadcrumbArr(path, data);


  if (window.menuByServer) {
    tool.sgiLogger.info(menuByServer);
    let res = getLastRoute(menuByServer, path);
    saveLastVisitRoute(res);
  }


  if (!data) {
    browserHistory.push({
      pathname: path,
      query: {}
    });
    return;
  }

  let key = tool.uuid();
  let value = escape(JSON.stringify(data));
  tool.sgiStorage.set(sgiConfig.keyPre_uuid + key, value);
  browserHistory.push({
    pathname: path,
    query: { uuid: key },
  });
};

tool.parseForBrowserHistory = (props) => {
  tool.sgiLogger.info(props);

  let location = props.location;

  if (!location) {
    return {};
  }

  let url = location.search; // 获取url中"?"符后的字串
  let theRequest = new Object();
  if (url.indexOf('?') != -1) {
    let str = url.substr(1);
    let strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }

  return JSON.parse((unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + theRequest.uuid))));
};

var callbackPool = {
  allCallbackPool: {
    offlineMsg: {
      msg: [],
      open: false
    },
    noticeMsg: {
      msg: [],
      open: false
    },
    onlineMsg: {
      chatView: false,
      open: false
    }
  },
  setCallbackInPool: (type, callback, openFlg) => {
    if (type == 'bellNum') {
      callbackPool.allCallbackPool.bellCallBack = callback;// 铃铛的回调函数
    } else
            if (type == 'onlineMsg') { // 打开消息对话窗的回调事件
              callbackPool.allCallbackPool.onlineMsg.open = openFlg;
              if (callback) {
                callbackPool.allCallbackPool.onlineMsg.callback = callback;// 对话窗的回调事件
              }
            } else
                if (type == 'offlineMsg') { // 非对话窗口的消息
                  callbackPool.allCallbackPool.offlineMsg.open = openFlg;
                  if (callback) {
                    callbackPool.allCallbackPool.offlineMsg.callback = callback;// 对话窗的回调事件
                  }
                } else
                    if (type == 'noticeMsg') { // 通知类消息
                      callbackPool.allCallbackPool.noticeMsg.open = openFlg;
                      if (callback) {
                        callbackPool.allCallbackPool.noticeMsg.callback = callback;// 对话窗的回调事件
                      }
                    }
  },
  getCallbackFromPool: (type, msg) => {
    tool.sgiLogger.info('执行回调函数--------------------------', callbackPool.allCallbackPool);
        // 如果消息类型是P2P、广播、通知则增加铃铛显示
    if (type == '02' || type == '03' || type == '04') {
      callbackPool.allCallbackPool.bellCallBack();// 铃铛的回调函数
    }
    if (type == '02' || type == '03') {
            // 将消息追加到列表头部

      callbackPool.allCallbackPool.offlineMsg.msg.unshift(msg);
      if (callbackPool.allCallbackPool.offlineMsg.callback) {
        callbackPool.allCallbackPool.offlineMsg.callback(callbackPool.allCallbackPool.offlineMsg.msg);
      }
            // if(!callbackPool.allCallbackPool.offlineMsg.open){
            //     callbackPool.allCallbackPool.offlineMsg.msg.unshift(msg);
            // }else{
            // callbackPool.allCallbackPool.offlineMsg.callback(msg);
            // }
    } else
            if (type == '04') {
                // 将消息追加到列表头部
              callbackPool.allCallbackPool.noticeMsg.msg.unshift(msg);
              if (callbackPool.allCallbackPool.noticeMsg.callback) {
                callbackPool.allCallbackPool.noticeMsg.callback(callbackPool.allCallbackPool.noticeMsg.msg);
              }
                // if(!callbackPool.allCallbackPool.noticeMsg.open){

                // }else{
                //     callbackPool.allCallbackPool.noticeMsg.callback(msg);
                // }
            }
  },

  addCallback: (type, contentType, callback) => {
    if (!type || !contentType) return;
    if (!callbackPool.allCallbackPool[type]) callbackPool.allCallbackPool[type] = {};
    callbackPool.allCallbackPool[type][contentType] = callback;
  },
  getCallback: (type, contentType) => {
    if (!type || !contentType) return null;
    if (!callbackPool.allCallbackPool[type]) return null;
    return callbackPool.allCallbackPool[type][contentType];
  }
};

/**
 * 客户化参数信息保存
 *  @param {object} root 需要保存的参数对象
 * 	@param {boolean} [async=false]	是否是同步
 *  @param {funciton} [callback=fun]	异步的回调函数
 *  @return {number} 0-成功，-1-失败
 */
tool.saveCustParams = function (root, async, callback, reqType) {
  if (!root) {
    return null;
  }
  if (!root && typeof root !== 'object') {
    return null;
  }

  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (root) {
    request.body = root;
  }
  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  sgiPfClient.restcall(sgiConfig.pf + '/cust/param/save', reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      root = res.body;
      tool.sgiLogger.info('保存成功', res.body);
      tool.popMessage('保存成功', 'success');

      Object.assign(root, newprm);
    } else {
      root = null;
      tool.sgiLogger.info('保存失败！', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(root);
    }
  }
  return root;
};
/**
* 通过sc客户化参数信息获取
* @param {string} ap
* @param {string} [sc]
* @param {string} [batch] 是否分批
* @param {boolean} [async=false]	是否是同步
* @param {funciton} [callback=fun]	异步的回调函数
* @returns {object[]} 返回符合条件的参数数组
*/
tool.postCustParamBySc = function (ap, sc, async, reqType, callback) {
  if (!ap && !sc) {
    return null;
  }

  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (true) {
    request.body = {};
  }

  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  let prms = [];
  sgiPfClient.restcall(sgiConfig.pf + `/cust/param/ap/${ap}/sc/${sc}`, reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      prms = res.body || [];
    } else {
      tool.sgiLogger.info('查询失败', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(prms);
    }
  }
  return prms;
};
/**
* 通过id客户化参数信息获取
* @param {string} [id]
* @param {string} [batch] 是否分批
* @param {boolean} [async=false]	是否是同步
* @param {funciton} [callback=fun]	异步的回调函数
* @returns {object[]} 返回符合条件的参数数组
*/
tool.getCustParamById = function (id, async, reqType, callback) {
  if (!id) {
    return null;
  }

  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (true) {
    request.body = {};
  }

  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  let prms = [];
  sgiPfClient.restcall(sgiConfig.pf + `/cust/param/id/${id}`, reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      prms = res.body;
    } else {
      tool.sgiLogger.info('查询失败', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(prms);
    }
  }
  return prms;
};

/**
* 客户化参数信息列表获取
* @param {object} ap
* @param {string} [batch] 是否分批
* @param {boolean} [async=false]	是否是同步
* @param {funciton} [callback=fun]	异步的回调函数
* @returns {object[]} 返回符合条件的参数数组
*/
tool.getCustParamsByCndt = function (ap, async, reqType, callback) {
  if (!ap) {
    return;
  }

  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (ap) {
    request.body = {
      values: {
        ap: ap
      }
    };
  }
  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  let prms = [];
  sgiPfClient.restcall(sgiConfig.pf + '/cust/param/list', reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      prms = res.body;
    } else {
      tool.sgiLogger.info('查询失败', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(prms);
    }
  }
  return prms;
};

/**
* 客户化参数信息列表,通过id集合删除
* @param {array} data
* @param {boolean} [async=false]	是否是同步
* @param {funciton} [callback=fun]	异步的回调函数
* @returns {object[]} 返回符合条件的参数数组
*/
tool.deleteCustParamByIds = function (data, async, reqType, callback) {
  if (!data) {
    return;
  }

  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (data) {
    request.body = data;
  }
  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  let prms = [];
  sgiPfClient.restcall(sgiConfig.pf + '/cust/param/del/ids', reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      prms = res.body;
      tool.sgiLogger.info('删除成功', res.body);
      tool.popMessage('删除成功', 'success');
    } else {
      tool.sgiLogger.info('删除失败', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(prms);
    }
  }

  return prms;
};

/**
* 客户化参数信息列表,根据SC删除
* @param {string} ap
* @param {string} sc
* @param {boolean} [async=false]	是否是同步
* @param {funciton} [callback=fun]	异步的回调函数
* @returns {object[]} 返回符合条件的参数数组
*/
tool.deleteCustParamBySc = function (ap, sc, async, reqType, callback) {
  if (!ap || !sc) {
    return null;
  }
  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (true) {
    request.body = {};
  }

  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  let prms = [];
  sgiPfClient.restcall(sgiConfig.pf + `/cust/param/del/ap/${ap}/sc/${sc}`, reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      prms = res.body;
      tool.sgiLogger.info('删除成功', res.body);
      tool.popMessage('删除成功', 'success');
    } else {
      tool.sgiLogger.info('删除失败', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(prms);
    }
  }
  return prms;
};

/**
* 客户化参数信息列表,根据id删除
* @param {string} id
* @param {boolean} [async=false]	是否是同步
* @param {funciton} [callback=fun]	异步的回调函数
* @returns {object[]} 返回符合条件的参数数组
*/
tool.deleteCustParamById = function (id, async, reqType, callback) {
  if (!id) {
    return null;
  }

  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (true) {
    request.body = {};
  }

  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  let prms = [];
  sgiPfClient.restcall(sgiConfig.pf + `/cust/param/del/id/${id}`, reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      prms = res.body;
      tool.sgiLogger.info('删除成功', res.body);
      tool.popMessage('删除成功', 'success');
    } else {
      tool.sgiLogger.info('删除失败', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(prms);
    }
  }
  return prms;
};

/**
* 客户化参数信息列表添加
* @param {string} ap
* @param {array} data
* @param {boolean} [async=false]	是否是同步
* @param {funciton} [callback=fun]	异步的回调函数
* @returns {object[]} 返回符合条件的参数数组
*/
tool.batchAddCustParams = function (ap, data, async, reqType, callback) {
  if (!data || !ap) {
    return;
  }

  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };


  if (data) {
    request.body = data;
  }
  let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
  if (!reqType) {
    reqType = 'POST';
    header['Content-Type'] = 'application/json; charset=utf-8';
  }
  request = tool.jsonToStr(request);

  let prms = [];
  sgiPfClient.restcall(sgiConfig.pf + `/cust/param/batch/ap/${ap}`, reqType, request, header, async || false, sucfunc);
  function sucfunc(res) {
    if (res && res.head && res.head.code == '0000') {
      prms = res.body;
      tool.sgiLogger.info('添加成功', res.body);
      tool.popMessage('添加成功', 'success');
    } else {
      tool.sgiLogger.info('添加失败', res.head ? res.head.msg : null);
      tool.popMessage(res.head.msg, 'error');
    }

    if (callback) {
      callback(prms);
    }


    return prms;
  }
};
/** *
* 消息类型 type
* p2p消息 02/ 广播 03  / 通知类 04
*/
/** *
* 内容类型 contentType
*  01普通消息 / 业务类 02（业务类消息，需要根据消息内容中的uid属性，跳转到对应的页面上去）/
*/


tool.callbackPool = callbackPool;



// WEBPACK FOOTER //
// ./apps/conf/sgiFunction.js